module.exports = __webpack_public_path__ + "img/document-3.065bcb2.jpg";